<script>
  // Перенос Line из parts.tsx. Простое значение — пропом v, сложное — слотом.
  export let k = '';
  export let v = undefined;
  export let tone = undefined;   // 'gold' | 'off'
</script>

<div class="mn-line">
  <span class="k">{k}</span>
  <span class={'v' + (tone ? ' ' + tone : '')}>{#if $$slots.default}<slot />{:else}{v}{/if}</span>
</div>
